// import actionTypes from '../actionTypes';
// import moment from 'moment';
// const { v4: uuidv4 } = require('uuid');
// let fakeName = [
// {name : "Carmen Cooke", phone: "9965939311", type : "Carmen type",message : "It looked like fun"},
// {name : "Avery Blake", phone: "9918957865", type : "Avery type",message : "I was bored"},
// {name : "Josh Jackson", phone: "9938170769", type : "Josh type",message : "My friends encouraged me to do so"},
// {name : "Francis Gardner", phone: "9896990428", type : "Francis type",message : "All of the above"},
// {name : "Marco Strong", phone: "9914962993", type : "Marco type",message : "None of the above"},
// {name : "Sandy Yang", phone: "9948640391", type : "Sandy type",message : "I often dream that I am drowning"},
// {name : "Alec Rush", phone: "9923201076", type : "Alec type",message : "Fighting or running away from war"},
// {name : "Ambrose Cowan", phone: "9994960251", type : "Ambrose type",message : "I dream that I am flying"},
// {name : "Sheena Hunter", phone: "9996429817", type : "Sheena type",message : "I often dream of animals"},
// {name : "Guadalupe Payne", phone: "9929992703", type : "Guadalupe type",message : "People and relationships"},
// {name : "Beryl Rios", phone: "9997893957", type : "Beryl type",message : "A dog or a wolf"},
// {name : "Tammi Booth", phone: "9947244193", type : "Tammi type",message : "A tiger/lion/jaguar"},
// {name : "Chrystal Blanchard", phone: "9993572858", type : "Chrystal type",message : "Gazelle/horse/giraffe"},
// {name : "Reyes Bishop", phone: "9943950788", type : "Reyes type",message : "Owl/falcon/eagle"},
// {name : "Arnoldo Crawford", phone: "9969601143", type : "Arnoldo type",message : "A dolphin"},
// {name : "Kari Rich", phone: "9986192588", type : "Kari type",message : "Nope - I am living life one day at a time"},
// {name : "Conrad Gaines", phone: "9971488332", type : "Conrad type",message : "Yes - I am halfway through it already!"},
// {name : "Candy Downs", phone: "9924305333", type : "Candy type",message : "Yes, but I only have a couple of items on it"},
// {name : "Elvis Durham", phone: "9906902655", type : "Elvis type",message : "No, but I do know what I want in life"},
// {name : "Ella Shannon", phone: "9929348871", type : "Ella type",message : "Yes, but it is hard to get to!"}
// ]

import actionTypes from "../actionTypes";
import { updateObjectByPath } from "../../modules/screens/chatscreen/utils";

// let fakeType = ['campaign', 'agent', 'customer'];
// /* fake data generator start */
// let message = {
//   "campaign": {
//     "id": "bc86960e-1be5-400e-806d-6bdd0c274455",
//     "name": "RCS"
//   },
//   "@timestamp": "2023-03-26T12:32:33.111Z",
//   "mSessionID": "04b68757-3e2f-4682-bb3e-23cec015b20b",
//   "templete": "Somewhere, something incredible is waiting to be known.",
//   "tenantId": "test1",
//   "responseStatus": "RCS_SENT",
//   "contact": {
//     "updateBy": "130ea8ce-3f0b-4d9c-b747-1b5ce093875f",
//     "Name": "Rahul",
//     "update_at": "2023-03-16T13:59:56.898Z",
//     "publicInfo": "84409ffa-81af-4b62-9107-bfbd2b810c9f",
//     "_id": "919662547231",
//     "phone_number": "919662547231",
//     "listId": "f219da6c-afaf-4db5-8413-cd3087268346"
//   },
//   "final_status": "READ",
//   "initdate": "26-03-2023",
//   "creationDate": "2023-03-26T12:34:09.546Z",
//   "senderId": "StreamMessageHandler",
//   "updated_date": "2023-03-26T12:34:09.545Z",
//   "originalTextSent": "Somewhere, something incredible is waiting to be known.",
//   "type": "cdrinsert",
//   "pushType": "rcscdr",
//   "timestamp": "2023-03-26T12:34:09.545Z",
//   // New Parnams need to add
//   provider: {
//     type : 'rcs',
//   },
//   sender: {
//     type : "campaign", // campaign, agent, customer
//   },
//   message: {
//     type : 'text', // text, media,
//     subtype : 'text' // image, document, location, text, contact,
//   }
// }
// let customer = {
//   browser :{
//     "device_name": "Unknown",
//     "browser_name": "Chrome",
//     "platform_name": "Generic Linux",
//     "browser_version": "97.0.4692.71",
//     "platform_version": "0"
//   },
//   mSessionID: "04b68757-3e2f-4682-bb3e-23cec015b20b",
//   contact: {
//     "updateBy": "130ea8ce-3f0b-4d9c-b747-1b5ce093875f",
//     "Name": "Rahul",
//     "update_at": "2023-03-16T13:59:56.898Z",
//     "publicInfo": "84409ffa-81af-4b62-9107-bfbd2b810c9f",
//     "_id": "919662547231",
//     "phone_number": "919662547231",
//     "listId": "f219da6c-afaf-4db5-8413-cd3087268346"
//   },
//   team: {
//     _id: "3efbf677-90c1-42ae-a3a2-aaf5f203e2a6",
//     name: "WWWWWWWWWWWWWWWWWWWWWWWWW"
//   },
//   message : [],
//   // New Params need to add
//   conversationType: "rcs",
//   snoozed_until: null,
//   muted: false,
//   status: "open",
//   initiated_at : "2023-04-06T09:34:33.222Z",
//   unread_count: 0,
// }
// let openList = [];
// for (let index = 0; index < 5; index++) {
//   let fake =  Math.floor(Math.random() * 2);
//   let customerTest = {...customer}
//       customerTest.contact = {...customer.contact}
//   customerTest.mSessionID = uuidv4();
//   customerTest.contact.Name = fakeName[index].name;
//   customerTest.contact.phone_number = fakeName[index].phone;
//   customerTest.contact._id = fakeName[index].phone;
//   customerTest.contact.type = fakeName[index].type;
//   customerTest.message = "";
//   customerTest.unread_count = Math.floor(Math.random() * 22);
//   let list = [];
//   for (let j = 0; j < 10; j++) {
//     let messageTest = {...message}
//     messageTest.mSessionID = customerTest.mSessionID;
//     messageTest.contact.Name = fakeName[index].name;
//     messageTest.contact.phone_number = fakeName[index].phone;
//     messageTest.contact._id = fakeName[index].phone;
//     messageTest.originalTextSent = fakeName[index].message;
//     messageTest.sender.type = fakeType[fake];
//     list.push(messageTest);
//   }
//   customerTest.message = list;
//   openList.push(customerTest)
// }

// let assignList = [];
// for (let index = 5; index < 11; index++) {
//   let customerTest = {...customer}
//       customerTest.contact = {...customer.contact}
//   let fake =  Math.floor(Math.random() * 2); ;
//   customerTest.mSessionID = uuidv4();
//   customerTest.contact.Name = fakeName[index].name;
//   customerTest.contact.phone_number = fakeName[index].phone;
//   customerTest.contact.type = fakeName[index].type;
//   customerTest.contact._id = fakeName[index].phone;
//   customerTest.unread_count = Math.floor(Math.random() * 22);
//   customerTest.message = "";
//   let list = [];
//   for (let j = 0; j < 10; j++) {
//     let messageTest = {...message}
//     messageTest.mSessionID = customerTest.mSessionID;
//     messageTest.contact.Name = fakeName[index].name;
//     messageTest.contact.phone_number = fakeName[index].phone;
//     messageTest.contact._id = fakeName[index].phone;
//     messageTest.originalTextSent = fakeName[index].message;
//     messageTest.sender.type = fakeType[fake];
//     list.push(messageTest);
//   }
//   customerTest.message = list;
//   assignList.push(customerTest)
// }
// /* fake data generator end */

// // const initialState = {
// //   customer : {},
// //   openList : openList,
// //   assignList : assignList,
// // };

// // export default (state = initialState, action) => {
// //   const newState = { ...state };
// //   let payload = action.payload || {};
// //   switch (action.type) {
// //     case actionTypes.SET_CURRENT_CUSTOMER:
// //       let customer = newState.openList && newState.assignList.find(cust => cust.mSessionID === payload.mSessionID) || {};
// //       newState.customer = customer;
// //       return newState;
// //     case actionTypes.SET_OPEN_LIST:
// //       newState.openList = payload.openList;
// //       return newState;
// //     case actionTypes.ADD_TO_OPEN_LIST:
// //       newState.openList.push(payload);
// //       return newState;
// //     case actionTypes.REMOVE_TO_OPEN_LIST:
// //       let openList = newState.openList ? newState.openList : [];
// //       newState.openList = openList.filter(cust => cust.mSessionID != cust.mSessionID);
// //       return newState;
// //     case actionTypes.SET_ASSIGN_LIST:
// //       newState.assignList = payload.assignList;
// //       return newState;
// //     case actionTypes.ADD_TO_ASSIGN_LIST:
// //       newState.assignList.push(payload);
// //       return newState;
// //     case actionTypes.REMOVE_TO_ASSIGN_LIST:
// //       let assignList = newState.assignList ? newState.assignList : [];
// //       newState.assignList = assignList.filter(cust => cust.mSessionID != cust.mSessionID);
// //       return newState;
// //     default:
// //       return state;
// //   }
// // };

// import actionTypes from '../actionTypes';
// import moment from 'moment';

// const initialState = {
//   leftSidebarType: "conversationScreen",
//   conversationList: [
//     {
//       "id": "contact1",
//       "name": "John Doe",
//       "status": "online",
//       "image": 'https://picsum.photos/200',
//       "unreadMessages": 3,
//       "lastActive": "2023-07-14T09:30:00Z",
//       "type": "whatsapp",
//       "lastMessage": {
//         "content": "Hello",
//         "id": "msg1",
//         "sender": "John Doe" | "You",
//         "status": "read" | "delivered" | "deleted",
//         "timestamp": "2023-07-14T09:30:00Z"
//       }
//     },t fakeName = [
// {name : "Carmen Cooke", phone: "9965939311", type : "Carmen type",message : "It looked like fun"},
// {name : "Avery Blake", phone: "9918957865", type : "Avery type",message : "I was bored"},
// {name : "Josh Jackson", phone: "9938170769", type : "Josh type",message : "My friends encouraged me to do so"},
// {name : "Francis Gardner", phone: "9896990428", type : "Francis type",message : "All of the above"},
// {name : "Marco Strong", phone: "9914962993", type : "Marco type",message : "None of the above"},
// {name : "Sandy Yang", phone: "9948640391", type : "Sandy type",message : "I often dream that I am drowning"},
// {name : "Alec Rush", phone: "9923201076", type : "Alec type",message : "Fighting or running away from war"},
// {name : "Ambrose Cowan", phone: "9994960251", type : "Ambrose type",message : "I dream that I am flying"},
// {name : "Sheena Hunter", phone: "9996429817", type : "Sheena type",message : "I often dream of animals"},
// {name : "Guadalupe Payne", phone: "9929992703", type : "Guadalupe type",message : "People and relationships"},
// {name : "Beryl Rios", phone: "9997893957", type : "Beryl type",message : "A dog or a wolf"},
// {name : "Tammi Booth", phone: "9947244193", type : "Tammi type",message : "A tiger/lion/jaguar"},
// {name : "Chrystal Blanchard", phone: "9993572858", type : "Chrystal type",message : "Gazelle/horse/giraffe"},
// {name : "Reyes Bishop", phone: "9943950788", type : "Reyes type",message : "Owl/falcon/eagle"},
// {name : "Arnoldo Crawford", phone: "9969601143", type : "Arnoldo type",message : "A dolphin"},
// {name : "Kari Rich", phone: "9986192588", type : "Kari type",message : "Nope - I am living life one day at a time"},
// {name : "Conrad Gaines", phone: "9971488332", type : "Conrad type",message : "Yes - I am halfway through it already!"},
// {name : "Candy Downs", phone: "9924305333", type : "Candy type",message : "Yes, but I only have a couple of items on it"},
// {name : "Elvis Durham", phone: "9906902655", type : "Elvis type",message : "No, but I do know what I want in life"},
// {name : "Ella Shannon", phone: "9929348871", type : "Ella type",message : "Yes, but it is hard to get to!"}
// ]

// let fakeType = ['campaign', 'agent', 'customer'];
// /* fake data generator start */
// let message = {
//   "campaign": {
//     "id": "bc86960e-1be5-400e-806d-6bdd0c274455",
//     "name": "RCS"
//   },
//   "@timestamp": "2023-03-26T12:32:33.111Z",
//   "mSessionID": "04b68757-3e2f-4682-bb3e-23cec015b20b",
//   "templete": "Somewhere, something incredible is waiting to be known.",
//   "tenantId": "test1",
//   "responseStatus": "RCS_SENT",
//   "contact": {
//     "updateBy": "130ea8ce-3f0b-4d9c-b747-1b5ce093875f",
//     "Name": "Rahul",
//     "update_at": "2023-03-16T13:59:56.898Z",
//     "publicInfo": "84409ffa-81af-4b62-9107-bfbd2b810c9f",
//     "_id": "919662547231",
//     "phone_number": "919662547231",
//     "listId": "f219da6c-afaf-4db5-8413-cd3087268346"
//   },
//   "final_status": "READ",
//   "initdate": "26-03-2023",
//   "creationDate": "2023-03-26T12:34:09.546Z",
//   "senderId": "StreamMessageHandler",
//   "updated_date": "2023-03-26T12:34:09.545Z",
//   "originalTextSent": "Somewhere, something incredible is waiting to be known.",
//   "type": "cdrinsert",
//   "pushType": "rcscdr",
//   "timestamp": "2023-03-26T12:34:09.545Z",
//   // New Parnams need to add
//   provider: {
//     type : 'rcs',
//   },
//   sender: {
//     type : "campaign", // campaign, agent, customer
//   },
//   message: {
//     type : 'text', // text, media,
//     subtype : 'text' // image, document, location, text, contact,
//   }
// }
// let customer = {
//   browser :{
//     "device_name": "Unknown",
//     "browser_name": "Chrome",
//     "platform_name": "Generic Linux",
//     "browser_version": "97.0.4692.71",
//     "platform_version": "0"
//   },
//   mSessionID: "04b68757-3e2f-4682-bb3e-23cec015b20b",
//   contact: {
//     "updateBy": "130ea8ce-3f0b-4d9c-b747-1b5ce093875f",
//     "Name": "Rahul",
//     "update_at": "2023-03-16T13:59:56.898Z",
//     "publicInfo": "84409ffa-81af-4b62-9107-bfbd2b810c9f",
//     "_id": "919662547231",
//     "phone_number": "919662547231",
//     "listId": "f219da6c-afaf-4db5-8413-cd3087268346"
//   },
//   team: {
//     _id: "3efbf677-90c1-42ae-a3a2-aaf5f203e2a6",
//     name: "WWWWWWWWWWWWWWWWWWWWWWWWW"
//   },
//   message : [],
//   // New Params need to add
//   conversationType: "rcs",
//   snoozed_until: null,
//   muted: false,
//   status: "open",
//   initiated_at : "2023-04-06T09:34:33.222Z",
//   unread_count: 0,
// }
// let openList = [];
// for (let index = 0; index < 5; index++) {
//   let fake =  Math.floor(Math.random() * 2);
//   let customerTest = {...customer}
//       customerTest.contact = {...customer.contact}
//   customerTest.mSessionID = uuidv4();
//   customerTest.contact.Name = fakeName[index].name;
//   customerTest.contact.phone_number = fakeName[index].phone;
//   customerTest.contact._id = fakeName[index].phone;
//   customerTest.contact.type = fakeName[index].type;
//   customerTest.message = "";
//   customerTest.unread_count = Math.floor(Math.random() * 22);
//   let list = [];
//   for (let j = 0; j < 10; j++) {
//     let messageTest = {...message}
//     messageTest.mSessionID = customerTest.mSessionID;
//     messageTest.contact.Name = fakeName[index].name;
//     messageTest.contact.phone_number = fakeName[index].phone;
//     messageTest.contact._id = fakeName[index].phone;
//     messageTest.originalTextSent = fakeName[index].message;
//     messageTest.sender.type = fakeType[fake];
//     list.push(messageTest);
//   }
//   customerTest.message = list;
//   openList.push(customerTest)
// }

// let assignList = [];
// for (let index = 5; index < 11; index++) {
//   let customerTest = {...customer}
//       customerTest.contact = {...customer.contact}
//   let fake =  Math.floor(Math.random() * 2); ;
//   customerTest.mSessionID = uuidv4();
//   customerTest.contact.Name = fakeName[index].name;
//   customerTest.contact.phone_number = fakeName[index].phone;
//   customerTest.contact.type = fakeName[index].type;
//   customerTest.contact._id = fakeName[index].phone;
//   customerTest.unread_count = Math.floor(Math.random() * 22);
//   customerTest.message = "";
//   let list = [];
//   for (let j = 0; j < 10; j++) {
//     let messageTest = {...message}
//     messageTest.mSessionID = customerTest.mSessionID;
//     messageTest.contact.Name = fakeName[index].name;
//     messageTest.contact.phone_number = fakeName[index].phone;
//     messageTest.contact._id = fakeName[index].phone;
//     messageTest.originalTextSent = fakeName[index].message;
//     messageTest.sender.type = fakeType[fake];
//     list.push(messageTest);
//   }
//   customerTest.message = list;
//   assignList.push(customerTest)
// }
// /* fake data generator end */

// // const initialState = {
// //   customer : {},
// //   openList : openList,
// //   assignList : assignList,
// // };

// // export default (state = initialState, action) => {
// //   const newState = { ...state };
// //   let payload = action.payload || {};
// //   switch (action.type) {
// //     case actionTypes.SET_CURRENT_CUSTOMER:
// //       let customer = newState.openList && newState.assignList.find(cust => cust.mSessionID === payload.mSessionID) || {};
// //       newState.customer = customer;
// //       return newState;
// //     case actionTypes.SET_OPEN_LIST:
// //       newState.openList = payload.openList;
// //       return newState;
// //     case actionTypes.ADD_TO_OPEN_LIST:
// //       newState.openList.push(payload);
// //       return newState;
// //     case actionTypes.REMOVE_TO_OPEN_LIST:
// //       let openList = newState.openList ? newState.openList : [];
// //       newState.openList = openList.filter(cust => cust.mSessionID != cust.mSessionID);
// //       return newState;
// //     case actionTypes.SET_ASSIGN_LIST:
// //       newState.assignList = payload.assignList;
// //       return newState;
// //     case actionTypes.ADD_TO_ASSIGN_LIST:
// //       newState.assignList.push(payload);
// //       return newState;
// //     case actionTypes.REMOVE_TO_ASSIGN_LIST:
// //       let assignList = newState.assignList ? newState.assignList : [];
// //       newState.assignList = assignList.filter(cust => cust.mSessionID != cust.mSessionID);
// //       return newState;
// //     default:
// //       return state;
// //   }
// // };

// import actionTypes from '../actionTypes';
// import moment from 'moment';

const initialState = {
  showCustomerInfo: false,
  messageList: {},
  mainScreenLoading: false,
  paginationInfo: {},
  selectedAssignedList: {},
  leftSidebarType: "conversationScreen",
  unAssignedList: [],
  assignedList: [],
  disposeList: [],
  joinLoading: false,
  solveLoading: false,
  doneLoading: false,
  selectedImages: [],
  profile: {
    name: "",
    phoneNumber: "",
    status: "offline",
    team: "",
    image: "/images/ChatUnknownUser.svg",
  },
  retryImages: [],
  details: {
    assignScreen: true,
    newUnAssignedUsers: 0,
  },
  cannedMessages: [],
  // typingIndicatorCus: false,

  typingIndicatorCus: {},
  chatAgentAssist: [],
  loadingAssistMsg: false,
  disposeScreen: false,
  activeTab: 'reply',
  uniqueTeamIds: [],
  messageTagsList: [],
  messageListTag: [],
  messageFinalTag: {},
  messageSelectedTag: [],
  messageCommentTag: "",
  disposeList: [],
  currentLevelTags: [],
  listDispose: [],
  agentSummary: {},
  agentSummaryLoading: false,
  isAnalyticsEnabled: false,
  chatChecklist: [],
  activeTabRight: 'info',
  messageReply: "",
  messagePrivate: "",
  agentAssistReply: "",
  typingAssistCus: {},
  assistMessageList: [],
  showAgentAssistMsg: false,
  assistPaginationInfo: {},
  // chatChecklist: [
  //   {
  //     "name": "Greeting & Introduction",
  //     "topics": [
  //       {
  //         "topic": "Answer Promptly",
  //         "checked": true,
  //       },
  //       {
  //         "topic": "Introduce Yourself",
  //         "checked": true,
  //       }
  //     ]
  //   },
  //   {
  //     "name": "Active Listening & Issue Understanding",
  //     "topics": [
  //       {
  //         "topic": "Listen Attentively",
  //         "checked": false,
  //       }
  //     ]
  //   }
  // ],
};

export default (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.GLOBAL_DYNAMIC_UPDATE_CHAT:
      if (action.payload.data || action.payload.data == "") {
        if (action.payload.data.key.includes(".")) {
          updateObjectByPath(
            newState,
            action.payload.data.key,
            action.payload.data.value
          );
          return newState;
        }
        newState[action.payload.data.key] = action.payload.data.value;
      }
      return newState;

    // case actionTypes.CHAT_AGENT_ASSIST:
    //   const { data, identifier } = action.payload;
    //   // Ensure that both question and answer are saved correctly
    //   const existingEntries = newState.chatAgentAssist.filter(
    //     (item) => item.identifier === identifier
    //   );
    // newState.chatAgentAssist = [
    //   ...newState.chatAgentAssist.filter(
    //     (item) => item.identifier !== identifier
    //   ),
    //   { ...data, identifier },
    // ];
    // newState.chatAgentAssist = [...existingEntries, { ...data, identifier }];
    // return newState;
    case actionTypes.CHAT_AGENT_ASSIST:
      const { data, identifier } = action.payload;

      // Filter out the entries that have the same identifier as the current one
      const updatedEntries = newState.chatAgentAssist.filter(
        (item) => item.identifier !== identifier
      );

      // Add the existing entries back and include the new data for the current identifier
      newState.chatAgentAssist = [
        ...updatedEntries, // Keep all other identifiers' data
        ...newState.chatAgentAssist.filter(
          (item) => item.identifier === identifier
        ), // Preserve existing data for the current identifier
        { ...data, identifier }, // Add the new data for the current identifier
      ];
      return newState;

    case actionTypes.CLEAR_CHAT_AGENT_ASSIST:
      const { idf } = action.payload;
      // newState.chatAgentAssist = [];
      newState.chatAgentAssist = newState.chatAgentAssist.filter(
        (item) => item.identifier !== idf
      );
      return newState;

    case actionTypes.UPDATE_TRANSLATE:
      const { selectedChat, id, translateText } = action.payload;

      // Check if the selected chat exists in the messageList object
      if (selectedChat && newState.messageList[selectedChat]) {
        const updatedMessages = newState.messageList[selectedChat].map(
          (message) => {
            if (message && message.id === id) {
              return {
                ...message,
                message: {
                  ...message.message,
                  content: {
                    ...message.message.content,
                    translate: translateText || null, // Add translate field here
                  },
                },
              };
            }
            return message;
          }
        );

        const newStateWithUpdates = {
          ...newState,
          messageList: {
            ...newState.messageList,
            [selectedChat]: updatedMessages,
          },
        };

        return newStateWithUpdates;
      } else {
        return newState; // Return the current state if the id or selectedChat does not exist
      }

    case actionTypes.LOADING_AGENT_ASSIST:
      newState.loadingAssistMsg = action.payload;
      return newState;

    case actionTypes.SET_DISPOSE_SCREEN:
      newState.disposeScreen = action.payload;
      return newState;

    case actionTypes.SET_ACTIVE_TAB:
      newState.activeTab = action.payload;
      return newState;

    case actionTypes.SET_ACTIVE_TAB_RIGHT:
      newState.activeTabRight = action.payload;
      return newState;

    case actionTypes.SET_LIST_REDUX:
      newState.listDispose = action.payload;
      return newState;

    case actionTypes.SET_CURRENT_LEVEL_TAGS:
      newState.currentLevelTags = action.payload;
      return newState;


    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/store/reducers/chat.reducer.js